import Ajax from "Utils/ajax";
export const getStaffToEnterOpeningBalance = (data) => Ajax.post('hr/getStaffToEnterOpeningBalance',data); 
export const getAllCompanyList = (data) => Ajax.post('hr/getAllCompanyList',data);
export const insertLeaveOpBalance = (data) => Ajax.post('hr/insertLeaveOpBalance',data);